import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const sideBarSize = '5rem'

const useStyles = makeStyles((theme: Theme) => ({
  block: {
    width: sideBarSize,
    height: '100vh',
  },
}))

export { useStyles }
